import { For, Show } from "solid-js";
import { msg } from "@lingui/core/macro";
import { useI18n } from "@/providers/i18n-provider";
import { useAccounts } from "@/features/auth/use-accounts";
import { readTabAccountId } from "@/lib/tab-account";
import { Button } from "@/components/ui/button";

export function TryAnotherAccount() {
  const i18n = useI18n();
  const accounts = useAccounts();
  const activeId = readTabAccountId();

  const otherAccounts = () =>
    accounts.accounts().filter((a) => a.kind === "real" && a.userId !== activeId);

  return (
    <Show when={otherAccounts().length > 0}>
      <div class="mt-4 flex flex-col items-center gap-2 rounded-lg border bg-card p-4 text-center">
        <p class="text-xs text-muted-foreground">
          {i18n.t(msg`Signed in with more than one account? Try another one:`)}
        </p>
        <div class="flex flex-wrap justify-center gap-2">
          <For each={otherAccounts()}>
            {(account) => (
              <Button
                variant="outline"
                size="sm"
                onClick={() => {
                  void accounts.switchHere(account.userId);
                }}
              >
                {account.displayName || account.email}
              </Button>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
